export default class ExploreOurUniverse {
    constructor(element) {
        this.passedElement = element;
        this.searchQuery = "";
        this.init();
    }

    init = () => {
        if (!this.initialised) {
            this.initialised = true;
            this.getElements();
            this.addEventListeners();
        }
    }

    getElements = () => {
        this.nav = this.passedElement.querySelectorAll('.our-universe-filter li');
        this.grids = this.passedElement.querySelectorAll('.our-universe-grid');
    }

    setActiveCat = (elm) => {
        const cat = elm.getAttribute("data-cat");

        this.nav.forEach((nav) => nav.getAttribute("data-cat") === cat ? nav.classList.add("active") : nav.classList.remove("active"));
        this.grids.forEach((grid) => grid.getAttribute("data-cat") === cat ? grid.classList.add("active") : grid.classList.remove("active"));
    }

    addEventListeners = () => {
        this.nav.forEach((nav) => {
            nav.addEventListener('click', (e) => this.setActiveCat(e.target));
        });
    }

}